export const CHANGE_ZOOM = 'CHANGE_ZOOM';
export const CHANGE_CENTER = 'CHANGE_CENTER';
export const CHANGE_PITCH = 'CHANGE_PITCH';
export const CHANGE_BEARING = 'CHANGE_BEARING';
export const CHANGE_STYLE = 'CHANGE_STYLE';
export const CHANGE_MARKER = 'CHANGE_MARKER';
export const CHANGE_POPUPHTML = 'CHANGE_POPUPHTML';
export const CHANGE_MARKER_COLOR = 'CHANGE_MARKER_COLOR';
export const CHANGE_MAPTYPE = 'CHANGE_MAPTYPE';
export const CHANGE_POSTTYPE = 'CHANGE_POSTTYPE';
export const CHANGE_LATLNGREFS = 'CHANGE_LATLNGREFS';
export const CHANGE_MAPDATA = 'CHANGE_MAPDATA';
export const CHANGE_MAP_CATEGORIES = 'CHANGE_MAP_CATEGORIES';
export const CHANGE_MAP_LAYERS_FILTERS = 'CHANGE_MAP_LAYERS_FILTERS';
export const CHANGE_POPUP_STYLE = 'CHANGE_POPUP_STYLE';
export const CHANGE_CONTROL = 'CHANGE_CONTROL';
export const CHANGE_DIRECTIONS_PREFILL = 'CHANGE_DIRECTIONS_PREFILL';

export function changeControl(onoroff,type) {
  return {
    type : CHANGE_CONTROL,
    payload : {
      type : type,
      onoroff : onoroff
    }
  }
}

export function changePopupStyle(style) {
  return {
    type : CHANGE_POPUP_STYLE,
    payload : style
  }
}

export function changeMapData(data) {
  return {
    type : CHANGE_MAPDATA,
    payload : data
  }
}

export function changeMapLayersFilters(data) {
  return {
    type : CHANGE_MAP_LAYERS_FILTERS,
    payload : data
  }
}

export function changeMapCategories(data) {
  return {
    type : CHANGE_MAP_CATEGORIES,
    payload : data
  }
}

export function changeDirectionsPrefill(data) {
  return {
    type : CHANGE_DIRECTIONS_PREFILL,
    payload : data
  }
}

export function changePostType(type) {
  return {
    type : CHANGE_POSTTYPE,
    payload : type
  }
}

export function changeMapType(type) {
  return {
    type : CHANGE_MAPTYPE,
    payload : type
  }
}

export function changeLatLngRefs(refs) {
  return {
    type : CHANGE_LATLNGREFS,
    payload : refs
  }
}

export function changeStyle(style) {
  return {
    type : CHANGE_STYLE,
    payload : style
  }
}
export function changeZoom(zoom) {
  return {
    type : CHANGE_ZOOM,
    payload : zoom
  }
}
export function changeCenter(center) {
  return {
    type : CHANGE_CENTER,
    payload : center
  }
}
export function changePitch(pitch) {
  return {
    type : CHANGE_PITCH,
    payload : pitch
  }
}
export function changeBearing(bearing) {
  return {
    type : CHANGE_BEARING,
    payload : bearing
  }
}
export function changePopupHTML(html) {
  return {
    type : CHANGE_POPUPHTML,
    payload : html
  }
}
export function changeMarker(icon) {
  return {
    type : CHANGE_MARKER,
    payload : icon
  }
}
export function changeMarkerColor(hex) {
  return {
    type : CHANGE_MARKER_COLOR,
    payload : hex
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js